<div [ngClass]="{'td-wb-detailed-symbol-header__without-border': displaySymbolDetail}"
     class="td-wb-detailed-symbol-header">
  <div class="td-wb-detailed-symbol-header__content">
    @if (!displaySymbolDetail) {
      <h2 class="td-wb-detailed-symbol-header__title"
          [ngClass]="{'td-wb-detailed-symbol-header__title-with-exchanges': hasInterlistedExchanges()}">
        <!-- Title (No title for index) -->
        @if (!isIndex() && !isOption() && !viewSizeCompact) {
          <div [innerText]="quote.name"></div>
          <span>&nbsp;</span>
        }
        @if (isStockEtf()) {
          @if (!viewSizeCompact) {
            <span>|&nbsp;</span>
          }
          @if (!hasInterlistedExchanges()) {
            <div><span [innerText]="quote.market"></span>&nbsp;:&nbsp;</div>
          }
          <div [innerText]="quote.symbol"></div>
        } @else {
          <div [innerText]="quote.symbol"></div>
        }
      </h2>
    }
    <!-- Exchange selector for interlisted securities -->
    <div [ngClass]="{'td-wb-detailed-symbol-header__without-border': displaySymbolDetail}">
      @if (showInterlistedExchanges()) {
        <div
          class="td-wb-detailed-symbol-header-exchange-selector">
          <span class="td-wb-vh"
                id="td-wb-quote-header-view-on-label"
                translate="tdWb.markets.quote.VIEW_ON"></span>
          <td-wb-split-buttons class="td-wb-detailed-symbol-header-exchange-selector__buttons"
                               [ariaLabelledBy]="'td-wb-quote-header-view-on-label'"
                               [ngModel]="selectedMarket"
                               (ngModelChange)="onShowInterlistedExchangeQuote()">
            @for (market of markets; track market) {
              <td-wb-split-button [value]="market"
                                  [attr.title]="market">
                <td-wb-split-button-data class="td-wb-detailed-symbol-header-exchange-selector__button-label"
                                         [innerText]="market" />
              </td-wb-split-button>
            }
          </td-wb-split-buttons>
        </div>
      }
      @if (displaySymbolDetail) {
        <div class="td-wb-detailed-symbol-header__detail-container">
          @if (isETF()) {
            <p class="td-wb-detailed-symbol-header__market"
               [innerText]="symbol.exchange | tdWbPlaceholder: { defaultValue:  '-' }"></p>
          }
          <td-wb-icon-flag [value]="symbol.market"
                           [title]="'tdWb.watchlist.overview.toolbar.MKT_' + symbol.market | tdWbTranslate"
                           [aria-label]="'tdWb.watchlist.overview.toolbar.MKT_' + symbol.market | tdWbTranslate" />
          <span class="td-wb-detailed-symbol-header__detail"
                [innerText]="symbol.symbol | tdWbPlaceholder: { defaultValue:  symbol.tickerSymbol }"></span>
          @if (!isETF()) {
            <div>
              <h3 class="td-wb-detailed-symbol-header__symbol-name"
                  [innerHTML]="symbol?.description | tdWbPlaceholder : { defaultValue: '-' }"></h3>
              <div class="td-wb-detailed-symbol-header__warnings-message">
                <td-wb-ticker-symbol-warnings [symbolStatus]="getSymbolStatus()" />
              </div>
              <h1 class="td-wb-detailed-symbol-header__symbol-description"
                  [innerText]="quote?.lastPrice  | tdWbCurrency : { format: 'c4-2', emptyPlaceholder:'-'}"></h1>
              <td-wb-todays-change [quote]="quote" />
            </div>
          }
        </div>
      }
    </div>
  </div>
  @if (showAddToWatchlist()) {
    @if (useSlider) {
      <td-wb-add-to-watchlist-slide class="td-wb-detailed-symbol-header__add-to-watchlist"
                                    tdWbAddToWatchlistToastMessage="tdWb.watchlist.toolbar.SYMBOL_ADDED"
                                    [symbol]="symbol" />
    } @else {
      <td-wb-add-to-watchlist class="td-wb-detailed-symbol-header__add-to-watchlist"
                              tdWbAddToWatchlistToastMessage="tdWb.watchlist.toolbar.SYMBOL_ADDED"
                              [symbol]="symbol" />
    }
  }
</div>
